import React from 'react';
import { ApolloClient, InMemoryCache, createHttpLink, ApolloProvider } from '@apollo/client';
import PlanBuilderTemplatesIndex from '../../../components/Admin/PlanBuilder/PlanBuilderTemplatesIndex';

const httpLink = createHttpLink({
  uri: '/graphql',
  credentials: 'same-origin',
  headers: { 'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content }
});

const client = new ApolloClient({ link: httpLink, cache: new InMemoryCache() });

const PlanBuilderTemplatesIndexContainer = (props) => (
  <ApolloProvider client={client}>
    <PlanBuilderTemplatesIndex {...props} />
  </ApolloProvider>
);

export default PlanBuilderTemplatesIndexContainer;



